import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  Select,
  SingleValueOption,
  Option as OptionType,
} from "@industriousoffice/react-components";
import { Account, Location } from "@/api/opb/opbTypes";

import { Option } from "./components";

interface LocationSelectProps {
  locations?: Location[];
  accounts?: Account[];
  accountId?: string;
  onChange?: (value: SingleValueOption) => void;
  isLoading: boolean;
  isDisabled?: boolean;
}

function AccountSelect(props: LocationSelectProps) {
  const { t } = useTranslation("paymentMethods");
  const {
    locations,
    accounts,
    accountId,
    onChange,
    isLoading,
    isDisabled = false,
  } = props;

  const options = useMemo(
    () =>
      !isLoading
        ? accounts?.map((account: Account) => {
            const location = locations?.find(
              (l: Location) => account.locationId === l._id
            );
            return {
              label: <Option location={location} account={account} />,
              value: account._id,
            };
          }) ?? []
        : [],

    [locations, accounts]
  );

  const value = (options?.find((o) => o?.value === accountId) ??
    "") as OptionType;

  return (
    <Select
      aria-label={t("Account and location")}
      customClasses={{
        control: "bg-white! min-h-10! payment-account-select-control",
      }}
      options={options}
      value={value}
      placeholder=""
      isDisabled={isLoading || isDisabled}
      onChange={onChange}
      data-testid="account-select"
    />
  );
}

export default AccountSelect;
